import React, {useEffect} from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import { Typography } from '@mui/material';
import {makeStyles} from "@material-ui/core/styles";
import wallPaper from "../assets/static/images/OMtmkr.jpg";
import {data, whyChooseUs} from "./configs/AboutData";
import {BRAND_HEADLINE, BRAND_NAME, META_CONTENT} from "../shared/consts";

const useStyles = makeStyles((theme) => ({
  heroContent: {
    padding: theme.spacing(14, 0, 6),
    backgroundImage: `url(${wallPaper})`,
    backgroundColor: 'rgba(0, 0, 0, 0.13)',
    backgroundBlendMode: 'darken',
    backgroundSize: 'cover'
  },
  sections: {
  },
  sectionTitles: {
    paddingBottom: '30px',
    fontWeight: 'bolder',
    paddingTop: '64px',
  },
  coreValues: {
    fontWeight: 'bold'
  }
}));


export default function About(props) {

  const classes = useStyles();

  useEffect(() => {

  }, [])

  return (
  <React.Fragment>
    <Helmet>
    <meta name="description"
          content={META_CONTENT} />
    <title>{BRAND_NAME} - {BRAND_HEADLINE}</title>
    </Helmet>
    <CssBaseline />
    <main>
    {/* Hero unit */}
    <div className={classes.heroContent}>
    <Breadcrumb>
      <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
      <BreadcrumbItem active>About</BreadcrumbItem>
    </Breadcrumb>
      <Container maxWidth="sm">
        <Typography
          component="h1"
          variant="h4"
          align="center"
          color="textPrimary"
          style={{fontWeight: 'bold'}}
          gutterBottom>
          <span style={{backgroundColor: 'rgb(245, 195, 0)', padding: '0.0em 0.2em 0.0em 0.2em'}}>About King Edwards Academy</span>
        </Typography>
      </Container>
    </div>
    </main>
    <div>
      <div className={classes.sections}>
        <Container maxWidth="md">
          <Typography
          component="h1"
          variant="h5"
          align="center"
          color="textPrimary"
          className={classes.sectionTitles}
          gutterBottom>
            Who we are
          </Typography>
          <Typography>
            King Edwards Academy Group of Schools (KEA) is a private high school located just outside Masvingo,
            Zimbabwe. The school opened its doors in January 2025 and is committed to delivering world-class
            education grounded in Christian values.
            <br/>
            <br/>
            As a registered institution with the Ministry of Primary and Secondary Education, King Edwards Academy
            offers both boarding and day school options, equipped with modern facilities designed to support
            academic excellence and student development.
            <br/>
            <br/>
            We offer both the Cambridge International and the ZIMSEC curricula, from Form 1 to Form 6. This
            prepares our learners for success anywhere in the world while keeping a strong pride in our national
            heritage.
            <br/>
            <br/>
            Our curriculum is a rich one. It runs from rigorous academics through to a full programme of sports,
            clubs and societies, because we believe a complete education develops the whole child and not only
            the examination result.
            <br/>
            <br/>
            We pride ourselves on strong local and international affiliations, particularly with top universities
            in the United Kingdom, giving our students a competitive advantage in pursuing higher education
            abroad.

          </Typography>
        </Container>
      </div>
      <div className={classes.sections}>
        <Container maxWidth="md">
          <Typography
          component="h1"
          variant="h5"
          align="center"
          color="textPrimary"
          className={classes.sectionTitles}
          gutterBottom>
            Why Choose KEA
          </Typography>
          {whyChooseUs.map((reason) => (
            <Typography key={reason.id} style={{paddingTop: '16px'}}>
              <span className={classes.coreValues}>{reason.title}</span>
              <br/>
              <span style={{color: '#686868'}}>{reason.desc}</span>
            </Typography>
          ))}
        </Container>
      </div>
    </div>
  </React.Fragment>
  );
}